var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { t } from "../I18N";
import LibraryFilters from "./components/LibraryFilters";
import ViewMetadataPanel from "./components/ViewMetadataPanel";
import SelectMultiplePanelContainer from "./containers/SelectMultiplePanelContainer";
import { FeatureToggleSemanticSearch } from "../SemanticSearch/components/FeatureToggleSemanticSearch";
import SemanticSearchPanel from "../SemanticSearch/components/SemanticSearchPanel";
import ImportPanel from "../Uploads/components/ImportPanel";
import { LibraryFooter } from "./components/LibraryFooter";

class LibraryLayoutBase extends Component {
  render() {
    const {
      className,
      children,
      quickLabelThesaurus,
      sidePanelMode,
      scrollCallback,
      scrollCount,
      noindex
    } = this.props;
    const contentDivClass = `${
    quickLabelThesaurus ? 'with-header ' : ''} content-holder library-viewer document-viewer with-footer with-panel ${
    sidePanelMode} ]`;

    return (/*#__PURE__*/
      _jsx("div", { className: "row panels-layout", "data-testid": "library-content" }, void 0, /*#__PURE__*/
      _jsx(Helmet, {}, void 0, /*#__PURE__*/
      _jsx("title", {}, void 0, t('System', 'Library', null, false)),
      noindex && /*#__PURE__*/_jsx("meta", { name: "robots", content: "noindex" })
      ), /*#__PURE__*/
      _jsx("div", { className: contentDivClass, onScroll: scrollCallback }, void 0, /*#__PURE__*/
      _jsx("main", { className: `${className}` }, void 0, children), /*#__PURE__*/
      _jsx(LibraryFooter, { storeKey: "library", scrollCount: scrollCount }), /*#__PURE__*/
      _jsx(LibraryFilters, { storeKey: "library", sidePanelMode: sidePanelMode }),
      !quickLabelThesaurus && /*#__PURE__*/_jsx(ViewMetadataPanel, { storeKey: "library" }),
      !quickLabelThesaurus && /*#__PURE__*/_jsx(SelectMultiplePanelContainer, { storeKey: "library" }), /*#__PURE__*/
      _jsx(FeatureToggleSemanticSearch, {}, void 0, /*#__PURE__*/
      _jsx(SemanticSearchPanel, { storeKey: "library" })
      ), /*#__PURE__*/
      _jsx(ImportPanel, {})
      )
      ));

  }
}

LibraryLayoutBase.defaultProps = {
  className: '',
  quickLabelThesaurus: '',
  sidePanelMode: '',
  scrollCallback: () => {},
  scrollCount: 0,
  noindex: false
};











export { LibraryLayoutBase };

export default connect((state, { noindex }) => {
  const { filters } = state.library.search;
  const _noindex = filters && Object.keys(filters).length > 0 || noindex;
  return {
    quickLabelThesaurus: state.library.sidepanel.quickLabelState.get('thesaurus'),
    noindex: _noindex
  };
})(LibraryLayoutBase);